<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols :md=4>
          <h5>Select Dashboard</h5>
          <b-form-select
            v-model="dashboard_selected"
            :options="listReportDashboards"

            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
          ></b-form-select>
        </b-col>
        <b-col v-if="selected_dashboard != null" cols :md=4>
          <h5 v-if="selected_dashboard !== 'TARGETS'">Select Report</h5>
          <h5 v-if="selected_dashboard === 'TARGETS'">Select Target</h5>
          <b-form-select
            v-model="report_selected"
            :options="listReports"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
          ></b-form-select>
        </b-col>
        <b-col v-if="selected_dashboard != null && selected_dashboard !== 'TARGETS'" :cols="2" class="text-left" style="margin-bottom: 10px">
            <h5>Select Date Range</h5>
            <vue-ctk-date-time-picker
              id="RangeDatePicker"  label="Select a date range" v-model="range_value"
              :custom-shortcuts="custom_shortcuts"
              format="YYYY-MM-DD" :range="true" formatted="ll">
                <b-button variant="primary"
                  class="m-2" size="md">Current Month</b-button>
              </vue-ctk-date-time-picker>
          </b-col>
        <b-col v-if="selected_dashboard != null && selected_dashboard === 'TARGETS' && this.selected_report_id !== null && this.selected_report_id !== 'all_targets'" :cols="2" class="text-left" style="margin-bottom: 10px">
          <h5>Select Year</h5>
          <b-form-select
          v-model="year_value"
          :options="year_options"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
          style="max-width: 300px;"
          size="lg"
          >
          </b-form-select>
          </b-col>
      </b-row>
    </b-card>
    <div class="text-center mt-5" v-if="selected_report == null && report_selected != null">
      <i class="fa fa-spinner fa-spin fa-5x"></i>
    </div>
    <div class="p-2" v-if="selected_report != null">
<!--      <customer-list-section-t :key="report_selected"-->
      <customer-list-section-t :key="report_selected_key"
        active
        :database="database"
        :data-type="database"
        :table_data="this.list_view_insights"
        :already_loaded="false"
        :table_columns="this.all_columns"
        disable-download
        :disable-sort="selected_dashboard === 'TARGETS'"
        :enable-filter="selected_dashboard !== 'TARGETS'"
        :selected_dashboard_id="this.selected_dashboard_id"
        :selected_report_id="this.selected_report_id"
        :report_title="this.report_title"
        :target_year="this.year_value"
        :start_date="this.start_date"
        :end_date="this.end_date"
        />

    </div>
  </div>
</template>

<script>
import CustomerSummaryView from './CustomerSummaryView';
import TabView from './TabView';
import ListReportsSection from '../Insights/ListReportsSection';
import CustomerListSectionT from '../Insights/CustomerListSectionT';
import axios from "axios";
import {fullURL} from "@/utils";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from "moment";
const parseCategory = (value, type) => {
  if (type === "date") {
    return moment(value).format("MMM DD, YYYY");
  }
  return value;
};



export default {
  name: 'SidebarTo360Lists',
  components: {
    CustomerSummaryView,
    TabView,
    ListReportsSection,
    CustomerListSectionT,
    VueCtkDateTimePicker
  },

  created() {
  },
  data() {

    const dashboards = this.$store.state.files.tableDashboards;
    const targetList = this.$store.state.files.targetList;
    const userDetails = this.$store.state.general.user
    console.log("dashboards", dashboards)
    return {
      list_view_insights: [],
      defaultCols: [],
      allCols: [],
      list_reports_dashboards: dashboards,
      list_targets_all: targetList,
      user: userDetails,
      all_current_month_target: [],
      selected_dashboard: null,
      selected_report: null,
      selected_report_id: null,
      selected_dashboard_id: null,
      dashboard_selected: null,
      report_selected: null,
      range_value:null,
      custom_shortcuts: [
          {
            key: 'alltime',
            label: 'All Time',
            value: () => {
              return {
                start: moment(this.selected_dashboard.start_date),
                end: moment().startOf('day').add(1, 'days')
              }
            }
          }, {
            key: 'today',
            label: 'Today',
            value: () => {
              return {
                start: moment().startOf('day'),
                end: moment().startOf('day').add(1, 'days')
              }
            }
          },
          { key: 'thisWeek', label: 'This week', value: 'isoWeek' },
          {key: 'lastWeek', label: 'Last week', value: '-isoWeek'},
          {key: 'last7Days', label: 'Last 7 days', value: 7},
          {key: 'last30Days', label: 'Last 30 days', value: 30},
          {key: 'thisMonth', label: 'This month', value: 'month'},
          {key: 'lastMonth', label: 'Last month', value: '-month'},
          {key: 'thisYear', label: 'This year', value: 'year'},
          {key: 'lastYear', label: 'Last year', value: '-year'}
        ],
      year_value:2021,
      year_options:[{item: 2021, name: 2021}, {item: 2020, name: 2020}],
      start_date: null,
      end_date: null,
      tableDescription: "",
      database:"sales",
      all_columns:[],
      report_title:"",
      report_selected_key: null
    };
  },
  computed: {
    listReportDashboards() {
      if (this.list_reports_dashboards.length === 1) {
        this.dashboard_selected = this.list_reports_dashboards[0]._id
      }
      let data = this.list_reports_dashboards.map( e =>({
               item: e._id,
               name: e.description
           }))
      if (this.list_targets_all.length > 0) {
        data.push({item: "targets", name: "Target Information"})
      } else {
        if ("permissions" in this.user) {
          if (this.user.permissions.includes("list_report_target_all")) {
            data.push({item: "targets", name: "Target Information"})
          }
        }
      }
      return data
    },

    listReports() {
      if (this.selected_dashboard === "TARGETS") {
        //todo: check if the user has the permission to view all targets
        let target_d = []
        console.log("user at target", this.user)
        if ("permissions" in this.user) {
          if (this.user.permissions.includes("list_report_target_all")) {
            target_d = [{item: -1, name: "All Targets"}]
          }
        }
        target_d = target_d.concat(this.list_targets_all.map(e => ({
          item: e.target_id,
          name: e.name
        })))
        return target_d
      } else {
        let reports = []
          if (this.selected_dashboard.title === "Overview") {
            reports = []
          }
          reports = reports.concat(this.selected_dashboard.report_type_reports.map(e => ({
          item: e._id,
          name: e.title
        })))
        return reports
      }
    },

  },

  watch:{
    dashboard_selected(val){
      console.log("selected ds", val)
    //  show a select for the reports
      if (this.selected_dashboard != null) {
        this.selected_dashboard = null
        this.selected_report = null
        this.report_selected = null
        this.report_selected_key = null
        this.report_title = ""
      }
      if ("targets" === val) {
        this.selected_dashboard = "TARGETS"
        this.selected_dashboard_id = "TARGETS"
      } else {
        this.list_reports_dashboards.forEach(dashboard => {
          if (dashboard._id === val) {
            this.selected_dashboard = dashboard
            this.selected_dashboard_id = dashboard._id
          }
        })
      }
      console.log("selected ds", this.selected_dashboard)
    },

    report_selected(val){
      this.report_selected_key = val
      this.report_changed(val)
    },
    range_value(val) {
      const {start, end} = val;
      if (start != null && end != null) {
        console.log("start_date", start);
        console.log("end_date", end);
        this.start_date = start;
        this.end_date = end;
        let temp_selected = this.report_selected
        this.report_selected = temp_selected
        this.report_selected_key = temp_selected + "}" + {"start": start, "end": end}
        console.log("report_selected_key", this.report_selected_key)
      } else {
        console.log("something is not complete")
      }
    },

    year_value(val) {
      let temp_selected = this.report_selected
      console.log("testing year selection", val)
      console.log("testing year selection2", temp_selected)
      this.report_selected = temp_selected
      this.report_selected_key = temp_selected + "}" + val.toString()
    }
  },

  methods: {
    report_changed(val) {
      console.log("selected report", this.report_selected)
      if (this.selected_dashboard === "TARGETS") {
        if (-1 === val) {
          //  all current target
          this.report_title = "All Targets"
          this.selected_report = this.all_current_month_target
          this.selected_report_id = "all_targets"
        }
        else {
          this.list_targets_all.forEach(target_data => {
            if (target_data.target_id === val) {
              this.report_title = target_data.name
              this.selected_report = target_data
              this.selected_report_id = val
            }
          })
      }
      } else {
          this.selected_dashboard.report_type_reports.forEach(report => {
            if (report._id === val) {
              this.report_title = report.title
                this.selected_report = report
                this.selected_report_id = val

            }
          })
      }
    }
  }


};
</script>

<style scoped>
.search {
  border-radius: 0;
  border: none;
  border-bottom: 1px solid var(--brand-primary-color);
}
</style>
